import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useShallowEqualSelector } from 'custom-hooks'
import { dateRangeConst } from 'constants/dateRangeConstants'
import moment from 'utils/momentInstanse'
import {
  getGroupDataSelector,
  getFacilityCountSelector,
} from 'redux/reducers/profile'
import {
  setGroupId,
  getGroupOverviewData,
  getLastUpdateDateSelector,
  getIsFetchingSelector,
  getGroupDataTotalSelector,
  getSelectedDateRangeSelector,
  setDefaultDateSelect,
  clearGroupData,
} from 'redux/reducers/overview'
import BarChart from 'components/BarCharts/BarChart'
import LastUpdateBlock from 'components/LastUpdateBlock/LastUpdateBlock'
import TopTotalInfo from 'components/TopTotalInfo/TopTotalInfo'
import Title from 'components/CommonUI/Title/Title'
import DateRangeFilterSection from './components/DateRangeFilterSection'
import FacilityMap from './components/FacilityMap'
import GroupInfoBlock from './components/GroupInfoBlock'
//import InsightsBlock from './components/InsightsBlock'

const Overview = () => {
  const dispatch = useDispatch()
  const { overviewId } = useParams()

  const { name, image_uri, created_at } =
    useShallowEqualSelector(getGroupDataSelector(overviewId)) || {}
  const lastUpdatetine = useShallowEqualSelector(getLastUpdateDateSelector)
  const isFetching = useShallowEqualSelector(getIsFetchingSelector)
  const locationsCount = useShallowEqualSelector(
    getFacilityCountSelector(overviewId)
  )
  const {
    total_cost,
    total_consumption,
    avg_energy_intensity: energy_intensity,
  } = useShallowEqualSelector(getGroupDataTotalSelector) || {}
  const selectedDateRange = useShallowEqualSelector(
    getSelectedDateRangeSelector
  )

  const [hoverFacilityId, setHovetFacility] = useState('')

  useEffect(() => {
    dispatch(
      setDefaultDateSelect({
        id: dateRangeConst.currentMonth.id,
        label: dateRangeConst.currentMonth.label,
        value: {
          start_timestmp: moment().startOf('month').utc().unix(),
          end_timestmp: moment().endOf('month').utc().unix(),
        },
      })
    )
  }, [dispatch])

  useEffect(() => {
    dispatch(clearGroupData())
    dispatch(setGroupId(overviewId))
    return () => {
      dispatch(clearGroupData())
      dispatch(setGroupId(null))
    }
  }, [overviewId, dispatch])

  useEffect(() => {
    dispatch(getGroupOverviewData())
  }, [overviewId, dispatch])

  return (
    <div className="overview_container">
      <div className="overview-content-holder">
        <div className="main_block">
          <Title title="Overview" />
          <DateRangeFilterSection selectedDateRange={selectedDateRange} />
        </div>
        <div className="aside_block">
          <LastUpdateBlock date={lastUpdatetine} />
        </div>
      </div>
      <div className="overview-content-wrapper">
        <div className="overview-main-content">
          <TopTotalInfo
            energy_intensity={energy_intensity}
            total_consumption={total_consumption}
            total_cost={total_cost}
            className="total"
            isFetching={isFetching}
          />
          <div className="bar-charts">
            <BarChart
              isFetching={isFetching}
              setHovetFacility={setHovetFacility}
            />
          </div>
          <FacilityMap
            hoverFacilityId={hoverFacilityId}
            selectedDateRange={selectedDateRange}
            groupId={overviewId}
          />
        </div>
        <div className="overview-aside-content">
          <GroupInfoBlock
            logoUrl={image_uri}
            name={name}
            facylitiCount={locationsCount}
            monitoringSinceDate={created_at}
          />
          {/* <InsightsBlock /> */}
        </div>
      </div>
    </div>
  )
}

export default Overview
